module.exports = __webpack_public_path__ + "img/file.bbb2dcb7.png";